import styled from '@emotion/styled';
import { SearchViewMode } from 'components/list-view-switcher/constants';

export const PlaceholderWrapper = styled.div<{ disableAnimation?: boolean; mode: SearchViewMode; }>`
  ${({ theme, mode }) => `
    ${mode === SearchViewMode.Grid ? `` : `
      display: flex;
    `}
  `}
  background: ${props => props.theme.colors.neutrals.white};
  margin: ${props => props.theme.spacing(2)} ${props => props.theme.spacing(0.5)} 0;
  padding: ${props => props.theme.spacing(0.5)};
  overflow: hidden;
  position: relative;

  div {
    border-radius: ${({ theme }) => theme.borderRadius.tiny};
  }

  ${({ theme, disableAnimation }) => `
    &:after {
      content: '';
      height: 600px;
      width: 15px;
      position: absolute;
      top: -150px;
      left: -100px;
      background: ${theme.colors.neutrals.white};
      filter: blur(10px);
      ${disableAnimation ? '' : 'animation: highlight 1.5s ease infinite;'}
      animation-direction: reverse;
    }

    @keyframes highlight {
      from {
        transform: translateX(-150px) rotate(-24deg);
      }
      to {
        transform: translateX(450px) rotate(-24deg);
      }
    }
  `}
`;

export const PlaceholderImage = styled.div<{ mode: SearchViewMode; }>`
  ${({ theme }) => `
    background-color: ${theme.colors.neutrals.grey9};
  `}

  ${({ theme, mode }) => theme.media.showAt({ to: 2 })`
    ${mode === SearchViewMode.Grid ? `
      height: 164px;
      margin-bottom: ${theme.spacing(1)};
    ` : `
      height: 140px;
      flex-basis: 124px;
      margin-left: ${theme.spacing(2)};
    `}
  `}

  ${({ theme, mode }) => theme.media.showAt({ from: 3 })`
    ${mode === SearchViewMode.Grid ? `
      height: 267px;
      margin-bottom: ${theme.spacing(2)};
    ` : `
      height: 104px;
      flex-basis: 192px;
      margin-left: ${theme.spacing(2)};
    `}
  `}
`;

export const PlaceholderContent = styled.div<{ mode: SearchViewMode; }>`
  ${({ theme }) => `
    flex-grow: 1;
    & > div {
      height: 20px;
      background-color: ${theme.colors.neutrals.grey10};
      margin-bottom: ${theme.spacing(1)};
    }
    & > div:nth-of-type(1) {
      width: 90px;
      background-color: ${theme.colors.neutrals.grey9};
    }

    & > div:nth-of-type(2), & > div:nth-of-type(3), {
      width: 80%;
    }

    & > div:nth-of-type(4) {
      width: 90px;
    }
  `}

  ${({ theme, mode }) => theme.media.showAt({ to: 2 })`
    ${mode === SearchViewMode.Grid ? `` : `
      & > div:nth-of-type(2), & > div:nth-of-type(3), {
        width: 183px;
      }
    `}
  `}

  ${({ theme, mode }) => theme.media.showAt({ from: 3 })`
    ${mode === SearchViewMode.Grid ? `` : `
      & > div:nth-of-type(2) {
        width: 80%;
      }
      & > div:nth-of-type(3), {
        width: 100%;
      }
    `}
  `}
`;
